import script from "./BillingDataPaid.vue?vue&type=script&setup=true&lang=ts"
export * from "./BillingDataPaid.vue?vue&type=script&setup=true&lang=ts"

import "./BillingDataPaid.vue?vue&type=style&index=0&id=5e24f80c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e24f80c"]])

export default __exports__